
  $(document).ready(function() {
    function runCounter($element) {
      var max_value = $element.attr('data-value');
      $({
        counter_value: $element.text()
      }).animate({
        counter_value: max_value
      }, {
        step: function step() {
          $element.text(Math.floor(this.counter_value));
        },
        duration: 1500,
        easing: 'swing',
        complete: function complete() {
          $element.text(this.counter_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        }
      });
    }
    var observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };
    var observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var $element = $(entry.target);
          runCounter($element);
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    $('.number-counter-value').each(function() {
      observer.observe(this);
    });
  });






